// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_a6-3";
export var contentContainer = "_a6-0";
export var editorContainer = "_a6-1";
export var quillInputForm = "_a6-2";
export var zoneDivider = "_a6-4";